import fetch from './fetch'

// 会员接口
let userCenter = (params) => fetch.get('/user/index', params)     // 会员中心
let register = (params) => fetch.get('/user/register', params)    // 注册
let login = (params) => fetch.get('/user/login', params)          // 登录
let logout = (params) => fetch.get('/user/logout', params)        // 注销登录
let resetpwd = (params) => fetch.get('/user/resetpwd', params)    // 重置密码
let getprofile = (params) => fetch.get('/user/getprofile', params)      // 个人信息
let saveProfile = (params) => fetch.post('/user/profile', params)       // 更新信息
let changeemail = (params) => fetch.get('/user/changeemail', params)    // 修改邮箱
let changemobile = (params) => fetch.get('/user/changemobile', params)    // 修改手机号
let getCustomerInfo = (params) => fetch.get('/user/salesman', params)    // 客服信息
let emailAuth = (params) => fetch.get('/user/email_auth', params)    // 邮箱认证
let mobileAuth = (params) => fetch.get('/user/mobile_auth', params)    // 手机号认证
let cardAuth = (params) => fetch.get('/user/card_auth', params)    // 身份证认证
let userAuth = (params) => fetch.get('/user/auth', params)    // 用户认证信息
let businessAuth = (params) => fetch.get('/user/business_auth', params)    // 企业认证

// 控制台
let getDashboardInfo = (params) => fetch.get('/user/dashboard', params)    // 控制台

// 首页 - 统计
let getStatistics = (params) => fetch.get('/index/Statistics', params)    // 统计

// 手机短信接口
let sendMsg = (params) => fetch.get('/sms/send', params)          // 发送验证码
let checkMsg = (params) => fetch.get('/user/qf_logsms/check', params)        // 检测验证码

// 邮箱验证码
let sendEmainMsg = (params) => fetch.get('/ems/send', params)        // 检测验证码
let checkEmainMsg = (params) => fetch.get('/ems/check', params)        // 检测验证码

// 图片验证码接口
let getImgCode = (params) => fetch.get('/captcha/index', params)          // 获取图片验证码
let checkImgCode = (params) => fetch.get('/captcha/check', params)        // 检测图片验证码

// 消息列表接口
let getMessageList = (params) => fetch.get('/message/index', params)          // 消息列表 /api/message/index

// SEO查询接口
let getkeylist = (params) => fetch.get('/seo/getkeylist', params)        // 快速排名查询
let getkeylistResource = (params) => fetch.resourceGet(params)        // 快速排名查询
//let getseoprice = (params) => fetch.get('/seo/getseoprice', params)      // seo优化价格查询
let getseoprice = (params) => fetch.get('/seo/getPrice', params)      // seo优化价格查询
let getseoPm = (params) => fetch.get('/seo/seopm', params)      // seo优化排名查询 /api/seo/seopm
let casesearch = (params) => fetch.get('/seo/casesearch', params)        // 案例查询
let getkeyinfo = (params) => fetch.get('/seo/getkeyinfo', params)        // 关键词详细信息
let getaddkeylist = (params) => fetch.get('/seo/getaddkeylist', params)        // 添加关键词

// 验证接口
let checkEmailAvailable = (params) => fetch.get('/validate/check_email_available', params)              // 检测邮箱
let checkUsernameAvailable = (params) => fetch.get('/validate/check_username_available', params)        // 检测用户名
let checkMobileAvailable = (params) => fetch.get('/validate/check_mobile_available', params)            // 检测手机
let checkMobileExist = (params) => fetch.get('/validate/check_mobile_exist', params)                    // 检测手机
let checkEmailExist = (params) => fetch.get('/validate/check_email_exist', params)                      // 检测邮箱
let checkSmsCorrect = (params) => fetch.get('/validate/check_sms_correct', params)                      // 检测手机验证码
let checkEmsCorrect = (params) => fetch.get('/validate/check_ems_correct', params)                      // 检测邮箱验证码

// 购物车接口
let addToCart = (params) => fetch.get('/cart/addcart', params)              // 添加购物车
let getCartList = (params) => fetch.get('/cart/cartlist', params)          // 购物车列表
let settleCart = (params) => fetch.get('/cart/settle', params)              // 购物车结算
let delCart = (params) => fetch.get('/cart/del', params)                    // 购物车删除

// 工单管理
let postWork = (params) => fetch.post('/work/post', params)              // 提交工单
let getWorkList = (params) => fetch.post('/work/index', params)              // 工单列表

// 邀请奖励
let getInvitaCode = (params) => fetch.post('/invita/getcode', params)              // 获取邀请码
let getInvitaRule = (params) => fetch.post('/invita/getrule', params)              // 获取邀请奖励规则
let getInvitaRecord = (params) => fetch.post('/invita/getRecord', params)          // 获取邀请奖励记录
let getInvitaNumber = (params) => fetch.post('/invita/invita_number', params)              // 获取奖励金额

// 用户提现
let financeWithdraw = (params) => fetch.post('/finance/withdraw', params)              // 用户提现
let financeWithdrawlist = (params) => fetch.post('/finance/withdrawlist', params)      // 用户提现列表
let financePay = (params) => fetch.post('/finance/pay', params)              // 充值支付

// 关键词接口
let getKeywordsList = (params) => fetch.get('/keywords/index', params)              // 关键词列表

// 文章接口
let getArticleCategory = (params) => fetch.get('/article/art_category', params)              // 文章分类
let getArticleList = (params) => fetch.get('/article/art_cate_list', params)              // 文章列表
let getArticleDetail = (params) => fetch.get('/article/art_detail', params)              // 文章详情

let getTradeRecord = (params) => fetch.get('/user/account_log', params)              // 交易记录
let getAllReturnRecord = (params) => fetch.get('/user/qf_log', params)              // 全返记录


let insertMessage = (params) => fetch.post('/worker/insertmessage', params)              // 插入聊天内容
let getMessage = (params) => fetch.get('/worker/getMessage', params)                    // 获取聊天内容

let setSite = (params) => fetch.get('/site/index', params)                      // 网站设置接口

let getKeywordsDetail = (params) => fetch.get('/keywords/s_detail', params)                      // 查看详情
let getSiteInfo = (params) => fetch.get('/site/index', params)                      // 网站信息
let getIntroduction = (params) => fetch.get('/index/introduction', params)                      // 平台介绍
let getContractInfo = (params) => fetch.get('/index/linkus', params)                      //  联系我们
let addMessage = (params) => fetch.post('/contact/add_message', params)                      //  添加留言
let getRankList = (params) => fetch.post('/invita/ranking', params)                      //  排行榜
let getService = (params) => fetch.post('/user/salesman', params)                      //  客服信息
let getServiceList = (params) => fetch.post('/article/appreciation_serve_lsit', params)    //  增值服务列表
let getServiceDetail = (params) => fetch.post('/article/appreciation_serve_detail', params)    //  增值服务详情
let getUnreadMsg = (params) => fetch.get('/message/unread_num', params)    //  消息未读条数
let updateMsgState = (params) => fetch.post('/message/update_msg_status', params)    //  更新消息状态
let deleteMsg = (params) => fetch.get('/message/del', params)    //  消息删除 /api/message/del
let getPayRule = (params) => fetch.get('/finance/pay_number', params)    //  获取充值金额
let getMyOrder = (params) => fetch.get('/finance/my_order', params)    //  我的订单
let getDepositInfo = (params) => fetch.get('/finance/over_withdraw', params)    //  提现统计
let getChargeRecord = (params) => fetch.get('/finance/recharge_record', params)    //  充值记录
let recharge = (params) => fetch.get('/order/integral_renewal_date', params)  //续费
let stopoptimize = (params) => fetch.get('/order/stop_optimize', params)  //停止 /api/order/stop_optimize
// let getKeyList = (params) => fetch.get('/order/keylist', params)  //续费
let addOrder = (params) => fetch.get('/order/add', params)      // 积分订单
let checkUsernameExist = (params) => fetch.get('/validate/check_username_exist', params)      // 检测用户名是否存在 /api/validate/check_username_exist
let gorecharge = (params) => fetch.post('/finance/pay',params)
let getline = (params) => fetch.post('/keywords/line',params) //排名详情
let getprev = (params) => fetch.get('/worker/chatlog',params)
let getzhu = (params) => fetch.get('/user/getzhu',params)
let getzhanbi = (params) => fetch.get('user/getzhanbi',params)
let uploadavatar = (params) => fetch.get('user/upload_avatar',params)
let getkeyinfobyid = (params) => fetch.get('seo/getkeyinfobyid',params)
//获取banner
let getBanner = (params)=>fetch.get('site/getBanner',params);
//提交关键词
let pushKey = (params)=>fetch.get('seo/pushKey',params);
//获取排名
let getPm = (params)=>fetch.get('seo/getPm',params);
let queryByManual = (params)=>fetch.get('seo/queryByManual',params)
let codepng = (params)=>fetch.get('captcha/index',params)
let getUserLevel = (params)=>fetch.get('user/getLevel',params)
let getMoreCase = (params)=>fetch.get('seo/getMoreCase',params)
let getSite = (params)=>fetch.get('site/getSite',params)
export let Api = {
  getSite,
  getMoreCase,
  getUserLevel,
  codepng,
  queryByManual,
  getPm,
  pushKey,
  getBanner,
  getkeyinfobyid,
  uploadavatar,
  getzhanbi,
  getzhu,
  getprev,
  getline,
  gorecharge,
  userCenter,
  register,
  login,
  logout,
  resetpwd,
  getprofile,
  saveProfile,
  changeemail,
  changemobile,
  getCustomerInfo,
  emailAuth,
  mobileAuth,
  cardAuth,
  userAuth,
  businessAuth,
  getDashboardInfo,
  getStatistics,
  sendMsg,
  checkMsg,
  sendEmainMsg,
  checkEmainMsg,
  getImgCode,
  checkImgCode,
  getMessageList,
  getkeylist,
  getkeylistResource,
  getseoprice,
  getseoPm,
  casesearch,
  getkeyinfo,
  getaddkeylist,
  checkEmailAvailable,
  checkUsernameAvailable,
  checkMobileAvailable,
  checkMobileExist,
  checkEmailExist,
  checkSmsCorrect,
  checkEmsCorrect,
  addToCart,
  getCartList,
  settleCart,
  delCart,
  postWork,
  getWorkList,
  getInvitaCode,
  getInvitaRule,
  getInvitaRecord,
  getInvitaNumber,
  financeWithdraw,
  financeWithdrawlist,
  financePay,
  getKeywordsList,
  getArticleCategory,
  getArticleList,
  getArticleDetail,
  getTradeRecord,
  getAllReturnRecord,
  insertMessage,
  getMessage,
  setSite,
  getKeywordsDetail,
  getSiteInfo,
  getIntroduction,
  getContractInfo,
  addMessage,
  getRankList,
  getService,
  getServiceList,
  getServiceDetail,
  getUnreadMsg,
  updateMsgState,
  deleteMsg,
  getPayRule,
  getMyOrder,
  getDepositInfo,
  getChargeRecord,
  recharge,
  stopoptimize,
  //getKeyList,
  addOrder,
  checkUsernameExist,
  fetch
}



// WEBPACK FOOTER //
// ./src/service/api.js